const WORDMARK_SIZES = {
  sm: 'text-xl',
  md: 'text-2xl',
  lg: 'text-4xl',
  xl: 'text-5xl',
};

export function RivlLogo({ className = '', size = 'lg' }) {
  return (
    <span
      data-testid="rivl-wordmark"
      className={`inline-flex items-baseline font-display font-black tracking-tight leading-none select-none ${WORDMARK_SIZES[size] || WORDMARK_SIZES.md} ${className}`}
      aria-label="RIVL"
    >
      <span className="text-primary">RI</span>
      <span className="text-foreground">V</span>
      <span className="text-[#1D4ED8]">L</span>
      <span className="text-primary">.</span>
    </span>
  );
}
